import React, { useState, useEffect } from "react";
import { useNavigate, useOutlet } from "react-router-dom";
import styled from "styled-components";
import {
  deliveryServiceList,
  deliverySettingState,
  DeliverySettingType,
} from "../../recoil/delivery";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import { useRecoilState, useRecoilValue } from "recoil";
import { currentStoreState, CurrentStoreType } from "../../recoil/auth";
import ApiController from "../../controller/ApiController";
import toast from "react-hot-toast";
import { useToast } from "../../controller/ToastController";
import { getRecoil, setRecoil } from "recoil-nexus";

const DeliverySetting = () => {
  const showToast = useToast();
  const currentStore = useRecoilValue<CurrentStoreType>(currentStoreState);

  const navigate = useNavigate();
  // const [selectedDelivery, set_selectedDelivery] = useState<string>("");
  // const [selectedDeliveryMode, set_selectedDeliveryMode] = useState<number>(-1);
  const [aList, set_aList] = useState<any>(deliveryServiceList);

  // const [deliverySetting, setDeliverySetting] =
  //   useRecoilState<DeliverySettingType>(deliverySettingState);
  const [deliverySetting, setDeliverySetting] = useState<DeliverySettingType>({
    type: "none",
    name: "해당없음",
    mode: -1,
    app_call_delay: 1000,
  });

  // 앱 딜레이 호출 시간
  const [appDelaySecond, set_appDelaySecond] = useState<number>(1000);

  const checkAlreadyRegisteredStore = async () => {
    try {
      const oParams = {
        store_id: currentStore.value?.store_id,
      };
      const oRes = await ApiController.delivery.checkAlreadyRegisteredStore(
        oParams
      );
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        if (oResponse.data) {
          return oResponse.data.alreadyRegistered;
        }
      }
      return false;
    } catch (e) {
      console.error("err =>", e);
    }
  };

  const changeDeliveryType = (sType: string, sName: string, iMode: number) => {
    let oValue: any = {
      type: sType,
      name: sName,
      mode: iMode,
    };
    if (deliverySetting) {
      oValue.app_call_delay = deliverySetting.app_call_delay;
    }

    // set_selectedDelivery(sType);
    // set_selectedDeliveryMode(iMode);
    setDeliverySetting(oValue);
  };

  const changeDeliveryMode = async (value: number) => {
    // let deliverySetting = AsyncLocalStorage.getItem("deliverySetting");
    // if (deliverySetting) {
    let oValue: any = {
      ...deliverySetting,
      mode: value,
    };

    if (value === 1) {
      const alreadyRegistered = await checkAlreadyRegisteredStore();
      if (!alreadyRegistered) {
        showToast(
          "바로고 등록 매장이 아닙니다.\n등록을 원하실 경우 고객센터에 문의해주세요",
          "error"
        );
        return;
      }
    }

    setDeliverySetting(oValue);
    // }
  };

  const addCount = () => {
    if (appDelaySecond < 5000) {
      let iNewValue = appDelaySecond + 500;
      set_appDelaySecond(iNewValue);
      if (deliverySetting) {
        setDeliverySetting({ ...deliverySetting, app_call_delay: iNewValue });
      }
    }
  };
  const subtractCount = () => {
    if (appDelaySecond > 500) {
      let iNewValue = appDelaySecond - 500;
      set_appDelaySecond(iNewValue);
      if (deliverySetting) {
        setDeliverySetting({ ...deliverySetting, app_call_delay: iNewValue });
      }
    }
  };

  const initSetting = () => {
    const deliverySettingTemp = getRecoil(deliverySettingState);

    console.log("deliverySettingTemp", deliverySettingTemp);
    if (
      deliverySettingTemp.app_call_delay &&
      typeof deliverySettingTemp.app_call_delay === "number"
    ) {
      setDeliverySetting(deliverySettingTemp);
      set_appDelaySecond(deliverySettingTemp.app_call_delay);
    } else {
      set_appDelaySecond(1000);
      if (deliverySettingTemp.app_call_delay) {
        setDeliverySetting({ ...deliverySettingTemp, app_call_delay: 1000 });
      }
    }
  };

  const saveDeliverySetting = () => {
    setRecoil(deliverySettingState, {
      ...deliverySetting,
      app_call_delay: appDelaySecond,
    });
    toast.success("변경된 배달설정을 저장했어요");
  };

  useEffect(() => {
    initSetting();
  }, []);

  useEffect(() => {
    set_aList([]);
    set_aList(deliveryServiceList);
    // const deliverySetting = AsyncLocalStorage.getItem("deliverySetting");
    // }, [selectedDelivery, selectedDeliveryMode]);
  }, [deliverySetting]);

  return (
    <Style>
      <div className="wrap" onClick={() => navigate("/")}></div>
      <div className="wrapContainer">
        <div className="modal">
          <div className="modalHeader">
            <h3>배달 설정</h3>
            <button onClick={() => navigate("/")}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
                alt="ic"
              />
            </button>
          </div>
          <div className="contentWrap">
            <div className="content">
              <h3>배달대행사 선택</h3>
              <div className="row">
                {deliverySetting &&
                  aList.map((oItem: any, index: number) => {
                    return (
                      <button
                        key={index}
                        className={`effectButton ${
                          oItem.type.indexOf(deliverySetting.type) !== -1 &&
                          "active"
                        }`}
                        onClick={() =>
                          changeDeliveryType(oItem.type, oItem.name, oItem.mode)
                        }
                      >
                        {oItem.name}
                      </button>
                    );
                  })}
              </div>
            </div>
            {deliverySetting.mode > -1 && (
              <div className="content reduceBottomMargin">
                <h3>배달 설정 방법</h3>
                <div className="toggle">
                  <button
                    className={`toggleItem left ${
                      deliverySetting.mode === 0 && "active"
                    }`}
                    onClick={() => changeDeliveryMode(0)}
                  >
                    배달 매크로
                  </button>
                  <button
                    className={`toggleItem right ${
                      deliverySetting.mode === 1 && "active"
                    }`}
                    onClick={() => changeDeliveryMode(1)}
                  >
                    API 연동
                  </button>
                </div>
              </div>
            )}
            {deliverySetting.mode < 1 && (
              <>
                <div className="content reduceBottomMargin">
                  <h3>호출 시간 설정</h3>
                  <div className="row">
                    <div className="countButton">
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus.svg`}
                        onClick={subtractCount}
                        alt="ic"
                      />
                      <p>{appDelaySecond}</p>
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_plus.svg`}
                        onClick={addCount}
                        alt="ic"
                      />
                    </div>
                    ms
                  </div>
                </div>
                <div className="row">
                  <h5>(호출 시간 설정 변경시 고객센터로 문의 부탁드립니다)</h5>
                </div>
              </>
            )}
            <div className="row horizontalSplitter"></div>
            <div className="content">
              <h4>
                이외 배달대행사는 빠르게 연동 준비중에 있습니다.
                <br />
                문의는 1670-5324로 연락 주세요.
              </h4>
            </div>
            <button className="save" onClick={saveDeliverySetting}>
              <h4>저장</h4>
            </button>
          </div>
        </div>
      </div>
    </Style>
  );
};
export default DeliverySetting;

const Style = styled.div`
  .wrap {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 100;
  }
  .wrapContainer {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 12px;
    z-index: 120;
  }
  .modal {
    height: auto;
    min-height: 450px;
    min-width: 50vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 120;
  }

  .row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    h5 {
      color: #000000;
      font-weight: 400;
    }
  }

  .horizontalSplitter {
    padding: 12px 0 10px 0;
  }

  .horizontalSplitter::after {
    height: 1px;
    background-color: #e2e2e2;
    width: 100%;
    display: block;
    content: "";
  }

  .modalHeader {
    padding: 4% 6%;
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    h3 {
      color: #333333;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      text-align: center;
    }

    button {
      position: absolute;
      right: 10px;
      top: 10px;
      padding: 10px;
    }
  }

  .contentWrap {
    padding: 30px 30px;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 6px;

    h3 {
      font-weight: 500;
      color: #333333;
      padding-bottom: 8px;
    }

    h4 {
      font-weight: 500;
      color: #333333;
      line-height: 24px;
    }

    p {
      font-size: 16px;
      line-height: 20px;
      color: #333333;
      font-weight: 400;
    }

    .content {
      margin-bottom: 14px;
    }
    .reduceBottomMargin {
      margin-bottom: 4px;
    }
  }

  .effectButton {
    padding: 6px 16px;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    background: #ffffff;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .effectButton.active {
    border: 1px solid #000000;
    background: #000000;
    color: #ffffff;
  }

  .countButton {
    border-radius: 3px;
    border: 1px solid #d2d2d2;
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;

    p.inactive {
      color: #ececec;
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .toggle {
    display: flex;
    align-items: center;
    border-radius: 5px;
    background: #ffffff;
    white-space: nowrap;
    .toggleItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
      padding: 10px 0;
      color: #adadad;
      font-size: 14px;
      font-weight: 600;
      border: 1px solid #d2d2d2;
    }
    .toggleItem.left {
      border-right: none;
      border-radius: 5px 0 0 5px;
    }
    .toggleItem.right {
      border-left: none;
      border-radius: 0 5px 5px 0;
    }
    .toggleItem.active {
      background: #000;
      color: #ffffff;
      border: 1px solid #000;
    }
  }

  button.save {
    width: 100%;
    padding: 10px 0;
    background-color: #000;
    border-radius: 5px;
    box-shadow: 0px 4px 4px 0px #00000040;
    h4 {
      color: #ffffff;
      font-weight: 600;
    }
  }
`;
